import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f16b8244"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "version-outdated-modal__wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "version-outdated-modal__spacer",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_3 = { class: "version-outdated-modal__card" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "version-outdated-modal__title" }, "Actualiza la aplicación", -1))
const _hoisted_5 = { class: "version-outdated-modal__text" }
const _hoisted_6 = { class: "version-outdated-modal__meta" }
const _hoisted_7 = { class: "version-outdated-modal__buttons" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "version-outdated-modal__spacer",
  "aria-hidden": "true"
}, null, -1))

import { onMounted } from 'vue'
import { IonButton, IonIcon, IonModal } from '@ionic/vue'
import { logoWhatsapp } from 'ionicons/icons'
import { useAppVersionCheck } from '@/composables/useAppVersionCheck'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppVersionOutdatedModal',
  setup(__props) {

const {
  isOpen,
  info,
  force,
  mensaje,
  localVersion,
  start,
  onActualizar,
  onWhatsapp,
  onMasTarde,
} = useAppVersionCheck()

onMounted(() => {
  start()
})

function onBackdropDismiss(): void {
  if (!force.value && isOpen.value) {
    onMasTarde()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonModal), {
    "is-open": _unref(isOpen),
    "backdrop-dismiss": !_unref(force),
    class: "version-outdated-modal",
    onDidDismiss: onBackdropDismiss
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(mensaje)), 1),
          _createElementVNode("p", _hoisted_6, [
            _createTextVNode(" Tu versión: "),
            _createElementVNode("strong", null, _toDisplayString(_unref(localVersion)), 1),
            (_unref(info)?.version_latest)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" · Disponible: "),
                  _createElementVNode("strong", null, _toDisplayString(_unref(info).version_latest), 1)
                ], 64))
              : _createCommentVNode("", true),
            (_unref(info)?.version_web && _unref(info).version_web !== _unref(info).version_latest)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" · Web: "),
                  _createElementVNode("strong", null, _toDisplayString(_unref(info).version_web), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(IonButton), {
              expand: "block",
              color: "primary",
              onClick: _unref(onActualizar)
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Actualizar ahora ")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_unref(IonButton), {
              expand: "block",
              color: "success",
              onClick: _unref(onWhatsapp)
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonIcon), {
                  slot: "start",
                  icon: _unref(logoWhatsapp)
                }, null, 8, ["icon"]),
                _createTextVNode(" Pedir asistencia por WhatsApp ")
              ]),
              _: 1
            }, 8, ["onClick"]),
            (!_unref(force))
              ? (_openBlock(), _createBlock(_unref(IonButton), {
                  key: 0,
                  expand: "block",
                  fill: "clear",
                  class: "version-outdated-modal__later",
                  onClick: _unref(onMasTarde)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Más tarde ")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_8
      ])
    ]),
    _: 1
  }, 8, ["is-open", "backdrop-dismiss"]))
}
}

})